import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {action, computed, observable} from 'mobx';
import isNull from 'lodash/isNull';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withStyles} from '@material-ui/core/styles';
import Close from 'react-icons/lib/io/close';
import BaseButton from '../../../components/button/BaseButton';
import {STEM_ACTION_MAX} from '../../../constants/constants';
import ExerciseInfo from './ExerciseInfo';
import './styles.scss';
import DialogWrapper from '../../../components/dialog/Dialog';
import {DialogTypes} from '../../../constants/enums';

const styles = () => ({
    paper: {
        overflow: 'hidden',
        background: 'none',
        boxShadow: 'none',
        width: 600
    }
});

@injectIntl
@inject('dialogStore', 'looperStore')
@observer
class ExerciseDialogContainer extends Component {
    @observable isChanged = false;

    @computed get disabled() {
        return !this.props.looperStore.activeExercise.ctaDescription || !this.isChanged;
    }

    @action setDisabled = (val) => {
        this.isChanged = val;
    };

    handleCtaDescription = ({target}) => {
        const {setActiveExercise, activeExercise} = this.props.looperStore;
        const ctaDescription = target.value.replace(/^\s+/g, '');
        this.setDisabled(true);
        setActiveExercise({...activeExercise, ctaDescription});
    };

    saveStemAction = () => {
        const {dialogStore, looperStore} = this.props;
        const {addCtaToLooper, editCtaInLooper, activeExercise} = looperStore;
        this.setDisabled(false);
        if (isNull(activeExercise.index)) {
            addCtaToLooper(activeExercise.ctaDescription);
        } else {
            editCtaInLooper(activeExercise.index);
        }
        looperStore.setActiveExercise({ctaDescription: '', index: null});
        dialogStore.closeDialog(DialogTypes.StemAction);
    };

    closeDialog = () => {
        const {looperStore, dialogStore} = this.props;
        this.setDisabled(false);
        looperStore.setActiveExercise({ctaDescription: '', index: null});
        dialogStore.closeDialog(DialogTypes.StemAction);
    };

    render() {
        const {dialogStore, classes, looperStore, intl: {formatMessage: translate}} = this.props;
        const {activeExercise} = looperStore;

        return (
            <DialogWrapper
                classes={{paper: classes.paper}}
                open={dialogStore.getDialogState(DialogTypes.StemAction)}
                onClose={this.closeDialog}>
                <div className="sa-dialog-head">
                    <button className="sa-dialog-close" onClick={this.closeDialog}><Close/></button>
                    <div className="head-text"><FormattedMessage id="looper.exercise.title" /></div>
                </div>
                <div className="sa-dialog-body">
                    <div className="sa-dialog-info">
                        <p><FormattedMessage id="looper.exercise.dialogDescription" /></p>
                        <i><FormattedMessage id="looper.exercise.dialogExample" /></i>
                    </div>
                    <ExerciseInfo
                        limit={STEM_ACTION_MAX}
                        counter={STEM_ACTION_MAX - activeExercise.ctaDescription.length}
                        value={activeExercise.ctaDescription}
                        placeholder={translate({id: 'looper.exercise.placeholder'})}
                        onChange={this.handleCtaDescription}
                    />
                </div>
                <div className="sa-dialog-foot">
                    <BaseButton
                        className="btn-cancel"
                        onClick={this.closeDialog}
                        label={translate({id: 'looper.exercise.cancelBtn'})}
                    />
                    <BaseButton
                        onClick={this.saveStemAction}
                        disabled={this.disabled}
                        label={translate({id: 'looper.exercise.saveBtn'})}
                    />
                </div>
            </DialogWrapper>
        );
    }
}

export default withStyles(styles)(ExerciseDialogContainer);
